import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import PageModal from '../common/PageModal'
import LoadingSpinner from '../common/LoadingSpinner'
import EmptyPageResults from '../common/EmptyPageResults'
import SimpleButton from '../common/SimpleButton'
import VideoModal from '../common/VideoModal'
import Dropdown from '../common/Dropdown'
import { ArrowBackThickIcon, VideoPlayIcon } from '../../icons'
import { getImageByModel } from '../../utils/functions'
import { trackEvent, gaActions, gaCategories } from '../../utils/ga4'
import './troubleshoot-details-modal.scss'

const TroubleshootDetailsModal = (props) => {
  const { t } = useTranslation()
  const history = useHistory()
  const { selectedProduct, cycles, selectedCycle, videos, selectedVideo, showSpinner, onSelectCycle, openVideoModal, closeVideoModal, closeModal, isEndUser } =
    props

  const troubleshootHeaderContent = () => {
    return (
      <div className="troubleshoot-header" onClick={() => handleCloseModal()}>
        <div className="back-button">
          <div className="back-icon">
            <ArrowBackThickIcon />
          </div>
        </div>
        <p className="title">{t('back')}</p>
      </div>
    )
  }

  const handleCloseModal = () => {
    trackEvent({
      action: gaActions.featureClick,
      category: gaCategories.troubleshootingPage,
      label: 'Troubleshooting Page: Mobile Modal Closed',
    })
    
    if (closeModal) {
      closeModal()
    }
  }

  const handleNavigateToVideos = () => {
    history.push({
      pathname: `/videos`,
      state: {
        model: selectedProduct,
      },
    })
  }

  return (
    <div className="troubleshoot-details-modal-wrapper">
      <PageModal toggle onToggle={() => handleCloseModal()} headerContent={troubleshootHeaderContent()}>
        <div className="troubleshoot-details-modal-content">
          <div className="product-card">
            <div className="image-wrapper d-flex flex-align-center">
              <img src={getImageByModel(selectedProduct)} className="img" alt={selectedProduct} />
            </div>
            <p className="product-name">{selectedProduct}</p>
          </div>
          <p className="cycle-select-title">{t('troubleshoot.select-option')}</p>
          <Dropdown
            className="dropdown-input"
            placeholder={t('troubleshoot.no-option')}
            options={cycles?.map((cycle) => ({ key: cycle.id, value: cycle.fault }))}
            initialSelectedKey={selectedCycle?.id}
            onChange={(cycle) => onSelectCycle(cycle.key)}
            withFiltering
          />

          {selectedCycle && (
            <div className="cycle-details-wrapper">
              <div className="cycle-title-wrapper">
                <div className="cycle-title">
                  <span>{t('fault')}</span>
                  <span className="cycle-title-number">{selectedCycle.fault}</span>
                </div>
                {selectedCycle.description?.length > 0 && (
                  <div className="cycle-category d-flex flex-column">
                    <ul className="list-none">
                      {selectedCycle.description.map((el, index) => (
                        <li key={index} className="cycle-categories">
                          <ul className="cycle-category-issue-list">
                            {el.split('\\n').map((desc, subIndex) => (
                              <li key={subIndex} className="cycle-description">
                                {desc}
                              </li>
                            ))}
                          </ul>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
              {selectedCycle.probable_cause?.length > 0 && (
                <div className="cycle-category d-flex flex-column">
                  <h3 className="cycle-category-title d-flex flex-align-center">{t('troubleshoot.probable-cause')}</h3>
                  <ul className="list-none">
                    {selectedCycle.probable_cause.map((el, index) => (
                      <li key={index} className="cycle-categories">
                        <ul className="cycle-category-issue-list">
                          {el.split('\\n').map((el, index) => (
                            <li key={index} className="cycle-category-issue">
                              {el}
                            </li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {!isEndUser && selectedCycle.tech_troubleshooting?.length > 0 && (
                <div className="cycle-category d-flex flex-column">
                  <h3 className="cycle-category-title d-flex flex-align-center">{t('troubleshoot.tech')}</h3>
                  <ul className="list-none">
                    {selectedCycle.tech_troubleshooting.map((el, index) => (
                      <li key={index} className="cycle-categories">
                        <ul className="cycle-category-issue-list">
                          {el.split('\\n').map((el, index) => (
                            <li key={index} className="cycle-category-issue">
                              {el}
                            </li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {selectedCycle.user_troubleshooting?.length > 0 && (
                <div className="cycle-category d-flex flex-column">
                  <h3 className="cycle-category-title d-flex flex-align-center">{t('troubleshoot.user-troubleshoot')}</h3>
                  <ul className="list-none">
                    {selectedCycle.user_troubleshooting.map((el, index) => (
                      <li key={index} className="cycle-categories">
                        <ul className="cycle-category-issue-list">
                          {el.split('\\n').map((el, index) => (
                            <li key={index} className="cycle-category-issue">
                              {el}
                            </li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {/*TODO: Add back section once videos for troubelshooting are ready */}
              {/* <div className="product-videos-wrapper">
                <div className="section-title">{t("nav.videos")}</div>
                <div className="videos-wrapper">
                  {videos.map((video, index) => (
                    <div
                      key={index}
                      className="video-item-wrapper"
                      onClick = {() => openVideoModal(video)}
                    >
                      <div className="thumbnail-wrapper">
                        <div className="thumbnail-icon">
                          <VideoPlayIcon />
                        </div>
                        <img
                          src={video.thumbnail_url}
                          alt="video"
                        />
                      </div>                
                      <p className="title">{video.title}</p>
                    </div>))
                  }
                  {videos.length === 0 && 
                    <div className="no-videos-wrapper">
                      <p className="disclaimer">{t("video_context.no_videos_yet")}</p>
                    </div>
                  }
                </div>
                <SimpleButton className="action-button" onClick={() => handleNavigateToVideos()}>
                  {t("video_context.view_all_videos")}
                </SimpleButton>
              </div> */}
            </div>
          )}
          {!selectedCycle && (
            <EmptyPageResults className="fit-within-page" title={t('troubleshoot.no-fault-selected')} subtitle={t('troubleshoot.select-fault')} />
          )}
        </div>
      </PageModal>
      {selectedVideo && <VideoModal title={selectedVideo.title} videoId={selectedVideo.video_id} onCloseVideo={closeVideoModal} />}
      {showSpinner && (
        <div className="spinner-wrapper">
          <LoadingSpinner />
        </div>
      )}
    </div>
  )
}

export default TroubleshootDetailsModal
